import { render, staticRenderFns } from "./VisualAnalysisTableHeader.vue?vue&type=template&id=983a9bb0&scoped=true&"
import script from "./VisualAnalysisTableHeader.vue?vue&type=script&lang=ts&"
export * from "./VisualAnalysisTableHeader.vue?vue&type=script&lang=ts&"
import style0 from "./VisualAnalysisTableHeader.vue?vue&type=style&index=0&id=983a9bb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "983a9bb0",
  null
  
)

export default component.exports